import type { components } from '@pba/types-openapi-client';
import { type UploadedFile, createUploadedFile } from '../uploaded-file';
import { type UserBase, createUserBase } from './base';
import type { Profession } from './profession';

export type UserList = {
  coverPhoto?: UploadedFile;
  profession: null | Profession;
  profilePhoto?: UploadedFile;
} & UserBase;

export const createUserList = (data: components['schemas']['UserList']): UserList => ({
  ...createUserBase(data),
  coverPhoto: data.cover_photo ? createUploadedFile(data.cover_photo) : undefined,
  profession: data.profession,
  profilePhoto: data.profile_photo ? createUploadedFile(data.profile_photo) : undefined,
});
